import { defineCommand } from '../../../concepts/commands/CommandDefinition';
import { Physicals } from '../../canvas/entities/Physicals';
import { IndexCard } from './IndexCard';

export const createIndexCard = defineCommand(
    'createIndexCard',
    'Create: Index Card',
    (r, [x, y]: [number?, number?]) => {
        Physicals.create(r, IndexCard, [x, y]);
    },
);
